export const constants = {
  SET_TOKEN_EXPIRED: "SET_TOKEN_EXPIRED",
  RESET: "RESET",
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
  HIDE_LOADER: "HIDE_LOADER",
  USER_CHECK_LOGIN: "USER_CHECK_LOGIN",
  SET_PERSON_DATA: "SET_PERSON_DATA",
  SET_PRACTITIONER_DATA: "SET_PRACTITIONER_DATA",
  SET_ORGANISATION_DATA: "SET_ORGANISATION_DATA",
  USER_LOGOUT: "USER_LOGOUT",
  LOGGING_OUT: "LOGGING_OUT",
  USER_DATA: "USER_DATA",
  RELATED_PERSONS_DATA: "RELATED_PERSONS_DATA",
  ACTIVE_PERSON_ID: "ACTIVE_PERSON_ID",
  SET_CURRENT_USER_SETTINGS: "SET_CURRENT_USER_SETTINGS",
  SET_VOICE_EDIT_SETTINGS: "SET_VOICE_EDIT_SETTIGNS",
  SET_CURRENT_USER_PRACTICE_DATA: "SET_CURRENT_USER_PRACTICE_DATA",
  SET_DASHBOARD_LOADED: "SET_DASHBOARD_LOADED",
  SET_IS_DIRTY: "SET_IS_DIRTY",
  SET_SHOW_BACKDROP: "SET_SHOW_BACKDROP",
  SHOW_LOADER: "SHOW_LOADER",
  HIDE_LOADER: "HIDE_LOADER",
  SET_SEARCH_KEYWORD: "SET_SEARCH_KEYWORD",
  SET_USER_TEMPLATE_PREFERENCES: "SET_USER_TEMPLATE_PREFERENCES",
  RESET_CONVERSATION: "RESET_CONVERSATION",
  RECORDING_STATUS: "RECORDING_STATUS",
  RECORDING_STOPPED: "RECORDING_STOPPED",
  RECORDING_PAUSED: "RECORDING_PAUSED",
  RECODING_DRAFT: "RECORDING_DRAFT",
  SET_TEMP_DATA: "SET_TEMP_DATA",
  SET_TEMP_DATA_RESET: "SET_TEMP_DATA_RESET",
  APPEND_TEMP_DATA: "APPEND_TEMP_DATA",
  NEW_VISIT_SELECTED: "NEW_VISIT_SELECTED",
  AUDIO_LANGUAGE: "AUDIO_LANGUAGE",
  PRINT_WATERMARK: "PRINT_WATERMARK",
  AUTO_DELETE_DAYS: "AUTO_DELETE_DAYS",
  SET_CONVERSATIONAL_LANGAUGE: "SET_CONVERSATIONAL_LANGAUGE",
  PROGRESS_STATUS: "PROGRESS_STATUS",
  SET_ENC_LOADING: "SET_ENC_LOADING",
  SET_TEMPLATE_LOADING: "SET_TEMPLATE_LOADING",
  IS_NJ_TEMPLATE_USER: "IS_NJ_TEMPLATE_USER",
  APP: {
    TOGGLE_LOADER: "TOGGLE_LOADER",
    UPDATE_ROUTES: "UPDATE_ROUTES",
    CHANGE_THEME: "CHANGE_THEME",
    FIRST_RENDER_UPDATE: "FIRST_RENDER_UPDATE",
    STORE_NOTIFICATIONS: "STORE_NOTIFICATIONS",
    CHANGE_ACTIVE_TAB: "CHANGE_ACTIVE_TAB",
    SIDEBAR_ACTIVE: "SIDEBAR_ACTIVE",
    OPEN_ALERT: "OPEN_ALERT",
    CLOSE_ALERT: "CLOSE_ALERT",
    SHOW_EDIT_DATA: "SHOW_EDIT_DATA",
    OFFLINE_FALLBACK: "OFFLINE_FALLBACK",
    FULL_PAGE_LOADER: "FULL_PAGE_LOADER",
    GENERATE_NOTIFICATIONS: "GENERATE_NOTIFICATIONS",
    CLEAR_NOTIFICATIONS: "CLEAR_NOTIFICATIONS",
    DELETE_NOTIFICATIONS: "DELETE_NOTIFICATIONS",
    READ_NOTIFICATIONS: "READ_NOTIFICATIONS",
    EDIT_WIDGET: "EDIT_WIDGET",
    SET_DASHBOARD_SELECTED_WIDGETS: "SET_DASHBOARD_SELECTED_WIDGETS",
    SET_FEATURE_AVAILABILITY: "SET_FEATURE_AVAILABILITY",
    OPEN_NOTIFICATION_MODAL: "OPEN_NOTIFICATION_MODAL",
    CLOSE_NOTIFICATION_MODAL: "CLOSE_NOTIFICATION_MODAL"
  },
  INSIGHTS: {
    SET_WIDGET_LOADING: "SET_WIDGET_LOADING",
  },
  TAB: {
    UPDATE_TAB_VALUE: "UPDATE_TAB_VALUE",
    UPDATE_SUBTAB_VALUE: "UPDATE_SUBTAB_VALUE",
  },
  APPOINTMENTS: {
    UPDATE_SELECTED_LOCATIONS: "UPDATE_SELECTED_LOCATIONS",
    UPDATE_SELECTED_DOCTORS: "UPDATE_SELECTED_DOCTORS",
  },
  TASKS: {
    TASK_DETAILS: "TASK_DETAILS",
  },
  PATIENTS: {
    PATIENT_OBJECT: "PATIENT_OBJECT",
  },
  ENCOUNTER: {
    ENCOUNTER_OBJECT: "ENCOUNTER_OBJECT",
    VISIT_OBJECT: "SCRIBE_OBJECT",
    ADD_VISIT: "ADD_VISIT",
    TOGGLE_SELECT: "TOGGLE_SELECT",
    ENCOUNTER_RESOURCE: "ENCOUNTER_RESOURCE",
    ARCHIVED_ENCOUNTER_RESOURCE: "ARCHIVED_ENCOUNTER_RESOURCE",
    SET_OBSERVATIONS: "SET_OBSERVATIONS",
    ENCOUNTER_NOTE: "ENCOUNTER_NOTE",
    QUICK_ACTION_TOGGLE: "QUICK_ACTION_TOGGLE",
    CONSOLIDATED_NOTE: "CONSOLIDATED_NOTE",
    FIRST_VISIT_SELECTED: "FIRST_VISIT_SELECTED",
    PREVIOUS_ENCOUNTER_OBSERVATIONS: "PREVIOUS_ENCOUNTER_OBSERVATIONS",
  },
  COPILOT: {
    SET_INTAKE_FORM: "SET_INTAKE_FORM",
    SET_INTAKE_FORM_LOADING: "SET_INTAKE_FORM_LOADING",
  },
  MOBILETAB: {
    SET_REDIRECT_POPUP: "SET_REDIRECT_POPUP",
  },
  SCRIBE: {
    SELECTED_TAB: "SELECTED_TAB",
    SHOW_POPUP: "SHOW_POPUP",
    SELECTED_TEMPLATE: "SELECTED_TEMPLATE",
    CDSS_REGEN_OBJ: "CDSS_REGEN_OBJ",
    AUTO_START: "AUTO_START",
    SET_SUBSCRIPTION_POPUP: "SET_SUBSCRIPTION_POPUP",
    SET_EXCEEDED_SUBSCRIPTION_POPUP: "SET_EXCEEDED_SUBSCRIPTION_POPUP",
    SET_MOBILE_COLLAPSE: "SET_MOBILE_COLLAPSE",
    SET_PERSIST_ENC_ID: "SET_PERSIST_ENC_ID",
    SHOW_JOT_POPUP: "SHOW_JOT_POPUP",
    SET_RENDER_TAB_VALUE: "SET_RENDER_TAB_VALUE",
    SET_CURRENT_EVENTS: "SET_CURRENT_EVENTS",
    SET_CDSS_EXISTS: "SET_CDSS_EXISTS",
    SHOW_TASK_ERROR_POPUP: "SHOW_TASK_ERROR_POPUP",
    SET_MIC_CLICKED: "SET_MIC_CLICKED",
    SHOW_ZOOM_POPUP: "SHOW_ZOOM_POPUP",
  },
  CDSS: {
    SET_ADD_SUFFIX: "SET_ADD_SUFFIX",
    UPDATE_CDSS_TITLE: "UPDATE_CDSS_TITLE",
  },
  QUICK_ACCESS: {
    PATIENT_DASHBOARD: {
      SET_IS_VISIBLE: "PATIENT_DASHBOARD/SET_IS_VISIBLE",
      SET_IS_DISABLED: "PATIENT_DASHBOARD/SET_IS_DISABLED",
    },
    RESET: "RESET",
    CLOSE_OVERLAY: "CLOSE_OVERLAY",
    SIDEBAR: {
      SET_IS_VISIBLE: "SIDEBAR/SET_IS_VISIBLE",
    },
  },
  SUBSCRIPTION: {
    SET_CURRENT_SUBSCRIPTION: "SET_CURRENT_SUBSCRIPTION",
    SET_AVAILABLE_PLANS: "SET_AVAILABLE_PLANS",
    RESET_SUBSCRIPTION: "RESET_SUBSCRIPTION",
  },
  LICENSE: {
    PACKAGE: "PACKAGE",
    PLAN_STATUS: "PLAN_STATUS",
  },
  RECOGNIZER: {
    SET_STT_TOKEN: "SET_STT_TOKEN",
    START_RECORDING: "START_RECORDING",
    PAUSE_RECORDING: "PAUSE_RECORDING",
    RESUME_RECORDING: "RESUME_RECORDING",
    STOP_RECORDING: "STOP_RECORDING",
    HAS_ERROR_ENCOUNTERED: "HAS_ERROR_ENCOUNTERED",
    STOP_RECORDING: "STOP_RECORDING",
    UPDATE_CDSS_DATA: "UPDATE_CDSS_DATA",
    LANGUAGE: "LANGUAGE",
    CONVERSATION_ENDING: "CONVERSATION_ENDING",
    RESET_RECOGNIZER_FOR_ENCOUNTER: "RESET_RECOGNIZER_FOR_ENCOUNTER",
    START_RECORDING_LOADING: "START_RECORDING_LOADING",
    AUTO_START: "AUTO_START",
    START_RECORDING_IN_PROGRESS: "START_RECORDING_IN_PROGRESS",
    SET_END_LOADING: "SET_END_LOADING",
    SET_CDSS_TITLE: "SET_CDSS_TITLE",
    UNSET_CDSS_TITLE: "UNSET_CDSS_TITLE",
    UPDATE_PROGRESS_STATE: "UPDATE_PROGRESS_STATE",
    RESET_PROGRESS_STATE: "RESET_PROGRESS_STATE",
    ZOOM_CALL_ONGOING: "ZOOM_CALL_ONGOING",
    SET_RECORDING_FALSE: "SET_RECORDING_FALSE",
    RESET_RECOGNIZER: "RESET_RECOGNIZER"
  },
  PLANS_USAGE: {
    FETCH_USAGE_REQUEST: "FETCH_USAGE_REQUEST",
    FETCH_USAGE_SUCCESS: "FETCH_USAGE_SUCCESS",
    FETCH_USAGE_FAILURE: "FETCH_USAGE_FAILURE",
  },
  CONSENT: {
    SET_CONSENT: "SET_CONSENT",
  },
  TEMPLATES: {
    ALL_TEMPLATES: "ALL_TEMPLATES",
    CURRENT_TEMPLATE: "CURRENT_TEMPLATE",
    RESET: "RESET",
  },
  BACKGROUND_TASKS: {
    MARK_AS_READ: "MARK_AS_READ",
    MARK_FAILED_AS_READ: "MARK_FAILED_AS_READ",
    REMOVE_ACTIVE_TASKS: "REMOVE_ACTIVE_TASKS",
    SHOW_TASK_INPROGRESS_POPUP: "SHOW_TASK_INPROGRESS_POPUP",
  },
  ACTIVE_SOAP_GENERATION: {
    ADD_ACTIVE_SOAP_GENERATION: "ADD_ACTIVE_SOAP_GENERATION",
    REMOVE_ACTIVE_SOAP_GENERATION: "REMOVE_ACTIVE_SOAP_GENERATION",
    SET_SHOW_PROGRESS_BAR: "SET_SHOW_PROGRESS_BAR",
    CLEAR_ALL_ACTIVE_SOAP_GENERATIONS: "CLEAR_ALL_ACTIVE_SOAP_GENERATIONS",
    REFRESH_PATIENT_HISTORY: "REFRESH_PATIENT_HISTORY",
    CLEAR_REFRESH_PATIENT_HISTORY: "CLEAR_REFRESH_PATIENT_HISTORY",
  },
};
